<template>
    <div>
        <!-- HEAD -->

        <div class="head row p-0 g-0" data-aos="fade-in" data-aos-delay="100" data-aos-duration="3000" >
            <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 p-0">
                <img :src="`${publicPath}img/01excelencia.jpg`" class="img-responsive">
            </div>
            <div class="headRight p-3 pt-xl-2 px-xl-5 px-xxl-0 ps-xxl-5">
                <div class="row justify-content-end">
                    <div class="col-2 m-0 me-3  mb-3 mt-3 p-0">
                        <img :src="`${publicPath}img/01excelencia-headIcon.gif`" class="img-responsive">
                    </div>
                </div>
                <h2>{{ $t('futuro.excelencia-operacional') }}</h2>
                <p class="text-end pt-2 pt-xl-3">{{ $t('excelence-intro') }}</p>
            </div>
        </div>

        <!-- end HEAD -->


        <div class="contingut bg-white row g-0 ">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-10 position-relative">
                    <div class="row align-items-top my-5">
                        <div class="col-12 text-center text-lg-start">
                            <h2 class="text-turquesa mb-4" data-aos="fade" data-aos-duration="1500">{{ $t('gestion-de-marcas-comerciales') }}</h2>
                            <p data-aos="fade-left" data-aos-duration="1000">{{ $t('roca-group-cuenta-con-mas-de') }}</p>
                        </div>
                    </div>
                    <div class="row fonsGris align-items-top mb-5 g-0 position-relative">
                        <div class="col-12 col-lg-4 px-4 pt-5 text-center text-lg-start" data-aos="fade" data-aos-duration="1500">
                            <h3 class="text-turquesa">{{ $t('marcas-globales') }}</h3>
                            <p>{{ $t('extienden-su-presencia-progresivament') }}</p>
                            <a class="btnCollapseIn btnFosc" data-bs-toggle="collapse" href="#collapse00" role="button" aria-expanded="false" aria-controls="collapse00"><i class="fa-solid fa-plus"></i></a>
                        </div>
                        <div class="blocCollapseR mt-5">
                            <div class="collapse collapseR" id="collapse00">
                                <div class="card card-body txtCollapse icoCollapse">
                                    <div class="row align-items-center">
                                        <div class="col-12">
                                            <div class="zonaCollapse pt-2">
                                                <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse00" role="button" aria-expanded="false" aria-controls="collapse00z"><i class="fa-solid fa-xmark"></i></a>
                                            </div>
                                        </div>
                                        <div class="col-10 m-auto py-0 py-lg-5 px-0 px-lg-5 text-center">
                                            <p>
                                                <img :src="`${publicPath}img/marcasE01.gif`" class="img-responsive mx-3 mb-5 mb-lg-0">
                                                <img :src="`${publicPath}img/marcasE02.gif`" class="img-responsive mx-3">
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-4 px-4 py-0 py-lg-5 text-center text-lg-start" data-aos="fade" data-aos-duration="1500">
                            <h3 class="text-turquesa">{{ $t('marcas-locales') }}</h3>
                            <p>{{ $t('aportan-un-valor-de-cercania') }}</p>
                            <a class="btnCollapseIn btnFosc" data-bs-toggle="collapse" href="#collapse01" role="button" aria-expanded="false" aria-controls="collapse01"><i class="fa-solid fa-plus"></i></a>

                        </div>
                        <div class="blocCollapseR mt-5">
                            <div class="collapse collapseR" id="collapse01">
                                <div class="card card-body txtCollapse icoCollapse">
                                    <div class="row align-items-center">
                                        <div class="col-12">
                                            <div class="zonaCollapse pt-2">
                                                <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse01" role="button" aria-expanded="false" aria-controls="collapse01"><i class="fa-solid fa-xmark"></i></a>
                                            </div>
                                        </div>
                                        <div class="col-12 m-auto py-0 py-lg-3 px-0 text-center">
                                            <p>
                                                <img :src="`${publicPath}img/marcasL01.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL02.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL03.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL04.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL05.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL06.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL07.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL08.gif`" class="img-responsive m-1">
                                            </p>
                                            <p>
                                                <img :src="`${publicPath}img/marcasL09.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL10.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL11.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL12.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL13.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL14.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL15.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL16.gif`" class="img-responsive m-1">
                                            </p>
                                            <p>
                                                <img :src="`${publicPath}img/marcasL17.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL18.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL19.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL20.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcasL21.gif`" class="img-responsive m-1">
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-4 px-4 pt-0 pt-lg-5 pb-0 pb-lg-5 text-center text-lg-start" data-aos="fade" data-aos-duration="1500">
                            <h3 class="text-turquesa">{{ $t('marcas-especialistas') }}</h3>
                            <p>{{ $t('se-circunscriben-a-canales-comerciales') }}</p>
                            <a class="btnCollapseIn btnFosc" data-bs-toggle="collapse" href="#collapse02" role="button" aria-expanded="false" aria-controls="collapse02"><i class="fa-solid fa-plus"></i></a>
                        </div>
                        <div class="blocCollapseR mt-5">
                            <div class="collapse collapseR" id="collapse02">
                                <div class="card card-body txtCollapse icoCollapse">
                                    <div class="row align-items-center">
                                        <div class="col-12">
                                            <div class="zonaCollapse pt-2">
                                                <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse02" role="button" aria-expanded="false" aria-controls="collapse02"><i class="fa-solid fa-xmark"></i></a>
                                            </div>
                                        </div>
                                        <div class="col-10 m-auto py-5 py-0 py-lg-5 px-lg-5 text-center">
                                            <p>
                                                <img :src="`${publicPath}img/marcas01.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcas02.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcas03.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcas04.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcas05.gif`" class="img-responsive m-1">
                                            </p>
                                            <p>
                                                <img :src="`${publicPath}img/marcas06.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcas07.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcas08.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcas09.gif`" class="img-responsive m-1">
                                                <img :src="`${publicPath}img/marcas10.gif`" class="img-responsive m-1">
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <hr class="bg-darkBlue">

                    <div class="row justify-content-between my-5 g-0">
                        <div class="col-12 col-lg-6 text-center text-lg-start py-2" data-aos="fade" data-aos-duration="1500">
                            <h2 class="text-turquesa mb-4">{{ $t('desarrollo-de-centros-de-competencia') }}</h2>
                            <p>{{ $t('en-2021-han-entrado-en-funcionamiento') }}</p>
                        </div>
                       <div class="col-12 col-lg-5 bg-foto" :style="{ backgroundImage: `url(${publicPath}img/01avanzandoCompetencia.jpg)` }"></div>
                    </div>

                    <hr class="bg-darkBlue">

                    <div class="row g-0 bg-darkBlue align-items-center mt-5" data-aos="fade" data-aos-duration="1500">
                                <div class="col-12 col-lg-8 col-xl-6 px-2 px-lg-5 pb-5 pb-lg-0 pt-5 pt-lg-0 text-center text-lg-start">
                                    <h2 class="text-turquesa m-0 mx-xxl-5 mb-3">{{ $t('gestion-centralizada-de-la-cadena-de-suministro') }}</h2>
                                    <p class="text-white m-0 mx-xxl-5">{{ $t('uno-de-los-proyectos-transversales') }}</p>
                                    <p class="text-white m-0 mx-xxl-5">{{ $t('esta-centralizacion-resulta-clave') }}</p>
                                    <p class="text-white m-0 mx-xxl-5">{{ $t('gracias-a-los-avances-alcanzados') }} </p>
                                </div>
                        <div class="col-12 col-lg-4 col-xl-6 m-0 p-0 text-center text-lg-end bg-darkBlue">
                            <img :src="`${publicPath}img/01excelenciaGestion.jpg`" class="img-responsive">
                        </div>
                    </div>
                <div class="row align-items-top my-5 py-5 pb-0 mb-0">
                    <div class="col-12 col-md-6 pe-0 pe-lg-5 pb-5 pb-lg-0 text-center text-lg-start" data-aos="fade-right" data-aos-duration="1500">
                        <img :src="`${publicPath}img/01excelenciaBusiness.jpg`" class="img-responsive">
                        <h3 class="text-blau py-3 text-center text-lg-start">{{ $t('roca-group-business-system-adaptacion-de-kaizen-para-la-mejora-continua-en-todos-los-procesos') }}</h3>
                        <p class="text-center text-lg-start">{{ $t('en-2021-se-ha-disenado-y-empezado-a-implementar') }}</p>
                    </div>
                    <div class="col-12 col-md-6 ps-0 ps-lg-5 pb-5 pb-lg-0 text-center text-lg-start" data-aos="fade-left" data-aos-duration="1500">
                        <img :src="`${publicPath}img/01excelenciaCalidad.jpg`" class="img-responsive">
                        <h3 class="text-blau py-3 text-center text-lg-start">{{ $t('gestion-global-de-la-calidad') }}</h3>
                        <p class="text-center text-lg-start">{{ $t('con-sede-en-gava') }} </p>
                    </div>

                  </div>
                </div>
            </div>

        </div>

        <div class="contingut bg-white row g-0 mb-5 pb-5">
            <div class="col-12 mt-5 py-5 mb-5 fonsGris position-relative">
                <h3 class="pb-3 mb-3">{{ $t('contribucion-a-los-ods') }}</h3>
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-3 col-xxl-2 col-md-auto mb-4 text-center text-lg-start">
                        <p>{{ $t('impacto-directo') }}</p>
                        <img :src="`${publicPath}img/01crecimiento-icono03.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01crecimiento-icono04.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01excelencia-icono03.gif`" class="img-responsive m-1">
                    </div>
                    <div class="col-md-auto border-start mb-4 text-center text-lg-start">
                        <p>{{ $t('impacto-indirecto') }}</p>
                        <img :src="`${publicPath}img/01excelencia-icono04.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01crecimiento-icono05.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01crecimiento-icono06.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01excelencia-icono07.gif`" class="img-responsive m-1">
                    </div>
                </div>
            </div>

            <hr>
            <div class="row p-0 g-0">
                <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-start">
                    <localized-link class="footerLink" to="/avanzando-hacia-el-futuro/crecimiento"><img :src="`${publicPath}img/breadcrumbBack.gif`" class="img-responsive" width="6"> {{ $t("nav.crecimiento") }}</localized-link>
                </div>
                <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-end">
                    <localized-link class="footerLink" to="/avanzando-hacia-el-futuro/innovacion">{{ $t("nav.innovacion") }} <img :src="`${publicPath}img/breadcrumbGo.gif`" class="img-responsive" width="6"></localized-link>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
  export default {
    name: "AvanzandoHaciaElFuturoExcelenciaOperacionalView",
      data() {
          return {
              publicPath: process.env.BASE_URL
          }
      }
  }

</script>
